module.exports = __webpack_public_path__ + "img/text_mobile1.b5412cf.svg";